<div modalHeader class="modal-header py-2">
  <h2 class="my-1"><b [innerText]="title"></b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="close()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <form *ngIf="form" [formGroup]="form" class="pb-8">
    <div class="form-group">
      <label for="reply-name" class="control-label">Name</label>
      <input
        id="reply-name"
        type="text"
        class="form-control"
        formControlName="name"
        placeholder="Enter reply name"
      />
      <control-messages [control]="form.get('name')"></control-messages>
    </div>


    <div class="form-group">
      <label for="reply-text" class="control-label">Text</label>
      <textarea
        id="reply-text"
        class="form-control"
        formControlName="text"
        placeholder="Enter reply text"
        rows="4"
        maxlength="320"
      ></textarea>
      <control-messages [control]="form.get('text')"></control-messages>
    </div>
  </form>
</div>

<div modalFooter class="row p-3">
  <div class="col">
    <button
      ngbAutofocus
      class="btn btn-info w-100"
      [disabled]="!form.valid || form.untouched || submitting"
      (click)="submit()"
    >Save changes</button>
  </div>

  <div class="col">
    <button class="btn btn-danger w-100" (click)="close()">Cancel</button>
  </div>
</div>
